import * as React from 'react';
import { ReactNode, useState } from 'react';

interface CollapsiblePanelProps {
  open?: boolean;
  children?: ReactNode[];
  index?: number;
  activeIndex?: number;
  onChange?: Function;
  imageSrc?: string;
  imageAlt?: string;
}

export default function CollapsiblePanel(props: CollapsiblePanelProps) {
  const [isOpen, setIsOpen] = useState<boolean>(props.open || false);

  const filteredChildren: ReactNode[] =
    props.children?.filter(
      // @ts-ignore
      (el: ReactNode) => !el?.type?.toString().includes('fragment')
    ) || [];

  const handleChange = () => {
    if (props.onChange !== undefined) {
      props.onChange(props.index, {
        imageSource: props.imageSrc,
        imageAlt: props.imageAlt
      });
    }
  };

  React.useEffect(() => {
    if (props.activeIndex !== props.index) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
      handleChange();
    }
  }, [props.activeIndex, isOpen]);

  React.useEffect(() => {
    if (props.open) {
      setIsOpen(true);
      handleChange();
    }
  }, []);

  return (
    <div className="t-20 collapsible-panel">
      <div
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleChange();
          }
        }}
        onClick={() => {
          handleChange();
        }}
        className="collapsible-panel-button"
      >
        {filteredChildren && filteredChildren[0]}
      </div>
      <div
        className={`collapsible-child ${
          isOpen ? ' expanded-child' : ' collapsed-child'
        }`}
      >
        {filteredChildren?.slice(1)}
      </div>
    </div>
  );
}
